import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={22.425}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 76644 87838"
    {...props}
  >
    <path
      d="M71752 49085c-2392 0-4380 1719-4804 3987h-8113L39225 32994V0h-1806v32994L17808 53072H9695c-424-2268-2412-3987-4804-3987-2702 0-4891 2189-4891 4890s2189 4891 4891 4891c2392 0 4380-1718 4804-3988h3160v4645c-2268 425-3986 2412-3986 4804 0 2701 2190 4891 4891 4891s4890-2190 4890-4891c0-2392-1719-4379-3989-4804v-4645h3147l19611 20080v3186c-2268 423-3987 2411-3987 4804 0 2701 2189 4890 4890 4890s4891-2189 4891-4890c0-2393-1718-4381-3988-4804v-3186l19611-20080h3155v4645c-2269 425-3987 2412-3987 4804 0 2701 2190 4891 4891 4891s4890-2190 4890-4891c0-2392-1719-4379-3987-4804v-4645h3153c424 2270 2412 3988 4803 3988 2701 0 4890-2190 4890-4891-1-2701-2191-4890-4892-4890zm-15441 3987H39225V35577l17086 17495zm-18892 0H20333l17086-17495v17495zm1806 16322c2270-424 3988-2412 3988-4804 0-2701-2190-4891-4891-4891s-4890 2190-4890 4891c0 2392 1718 4380 3987 4804v2980L20333 54878h35979L39225 72374v-2980z"
      style={{
        fill: "#231f20",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
